import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { WHEEL_PRIZES } from '@/entities/wheel/model/wheel.types';

import { formatDuration } from '@/shared/helpers/format-duration';

import { type PrizeNameProps } from './types';

import s from './index.module.scss';

export const ClickerPrizeName = ({ prize }: PrizeNameProps) => {
  const { t } = useTranslation();

  let description = t('to get $PlayCoin out of him');

  if (prize.type === WHEEL_PRIZES.CLICKER_XP) {
    description = t("He'll totally give you XP");
  }

  return (
    <>
      <div className={clsx(s.name, s.small)}>
        {t('Tap Yeti for 10 secs', {
          duration: formatDuration(+(prize.durationSeconds ?? 0), t, {
            withUnit: true,
          }),
        })}
      </div>
      <div className={clsx(s.description, s.small)}>{description}</div>
    </>
  );
};
